const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Reservations+API


function getReservations(profileId) {
    const url = `/api/users/profiles/${profileId}/reservations`;
    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getReservations;
